import { Component, Input, OnInit } from '@angular/core';
import { RmsModule } from '@rms';
import { Column } from '@interfaces';
import { LedgerService, RmsMessageService, RmsPulldownService } from '@services';
import { PeriodDetailComponent } from './period-detail/period-detail.component';

@Component({
  selector: 'app-accounting-periods',
  imports: [RmsModule],
  templateUrl: './accounting-periods.component.html',
  styleUrl: './accounting-periods.component.scss'
})
export class AccountingPeriodsComponent implements OnInit {
  @Input() canManage = false;

  Rows: any[] = [];
  Loading = false;

  Columns: Column[] = [
    { label: 'Period', key: 'PeriodName', width: 10 },
    { label: 'Start', key: 'StartDate', type: 'date', width: 10 },
    { label: 'End', key: 'EndDate', type: 'date', width: 10 },
    { label: 'Status', key: 'Status', width: 8, SearchType: 'select', cellClass: (row: any) => row.Status === 'Closed' ? 'period-closed' : 'period-open' },
    { label: 'Open Journals', key: 'OpenJournals', type: 'number', width: 9, align: 'right' },
    { label: 'Closed By', key: 'ClosedByName', width: 14 },
    { label: 'Closed On', key: 'ClosedDisplay', width: 13 },
    { label: 'Last Reason', key: 'StatusReason', width: 22 }
  ];

  constructor(private ledger: LedgerService, private message: RmsMessageService, private pulldown: RmsPulldownService) { }

  ngOnInit() { this.load(); }

  load() {
    this.Loading = true;
    this.ledger.getPeriods().subscribe({
      next: (rows) => {
        this.Loading = false;
        this.Rows = (rows || []).map((r: any) => ({
          ...r,
          ClosedDisplay: r.ClosedDate ? new Date(r.ClosedDate).toLocaleString() : '—'
        }));
      },
      error: (err) => {
        this.Loading = false;
        this.message.error('Failed to load periods: ' + (err?.error?.error || err?.message || 'Unknown error'));
      }
    });
  }

  open(row: any) {
    const ref = this.pulldown.open(PeriodDetailComponent, {
      title: `Period ${row.PeriodName}`,
      data: { Period: row, CanManage: this.canManage },
      width: '60vw',
      maxWidth: '95vw',
      maxHeight: '90vh',
      top: '0'
    });
    ref.afterClosed().subscribe(() => this.load());
  }
}
